import React, { useState } from "react";
import Images from "../../../media/images";
import { useForm } from "react-hook-form";
import api from "../../../api/api";
import { toast } from "react-toastify";

const UpdateEmployee = ({ item, setChange, change }) => {
  const { register, handleSubmit, unregister, setValue } = useForm();
  

  const handleSub = async (data) => {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("designation", data.designation);
    formData.append("contact_number", data.contact_number);
    formData.append("image", data.image[0]);
    formData.append("email", data.email);
    formData.append("address", data.address);
    formData.append("info", data.info);

    const { image, ...newDatas } = data;

    api
      .patch(
        `/info/employee-details/${item.id}/`,
        data.image.length === 0 ? newDatas : formData
      )
      .then((response) => {
        setChange(!change)
        toast.success("Data updated successfully");
      })
      .catch((error) => {
        toast.error("Error while updating");
      });
  };

  return (
    <div
      className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
      id="UpdateEmployeeModalDemo"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
        <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
          <div className="flex justify-end">
            <svg
              data-bs-dismiss="modal"
              aria-label="Close"
              className="text-primary-blue h-8 w-8"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
              />
            </svg>
          </div>
          <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
            <div>
              <div className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
                Update Employees
              </div>
              <div className="">
                <img
                  src={Images.title_border}
                  alt=""
                  className="mx-auto mt-4"
                />
              </div>

              <div className="my-2">
                <img src={item.image} className="w-56 object-fill m-auto" />
              </div>

              <form onSubmit={handleSubmit(handleSub)}>
                <div className="grid md:grid-cols-2">
                  <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
                    <label htmlFor="" className="text-primary-red">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="flex-grow py-2 px-2 outline-none"
                      id=""
                      placeholder="Name"
                      {...register(
                        "name",
                        { required: false },
                        setValue("name", item.name)
                      )}
                    />
                  </div>
                  <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
                    <label htmlFor="" className="text-primary-red">
                      Designation
                    </label>
                    <input
                      type="text"
                      name="designation"
                      className="flex-grow py-2 px-2 outline-none"
                      id=""
                      placeholder="Designation"
                      {...register(
                        "designation",
                        { required: false },
                        setValue("designation", item.designation)
                      )}
                    />
                  </div>
                  <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
                    <label htmlFor="" className="text-primary-red">
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name=""
                      className="flex-grow py-2 px-2 outline-none"
                      placeholder="Contact Number"
                      {...register(
                        "contact_number",
                        { required: false },
                        setValue("contact_number", item.contact_number)
                      )}
                    />
                  </div>
                  <div className=" border-2 border-primary-blue flex items-center gap-2 border-t-0 p-2 md:border-l-0">
                    <label htmlFor="" className="text-primary-red">
                      Image:
                    </label>
                    <input
                      type="file"
                      // name=""
                      className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                      id=""
                      {...register("image", { required: false })}
                      // onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-3 ">
                    <label htmlFor="" className="text-primary-red">
                      Email:
                    </label>
                    <input
                      type="text"
                      name="email"
                      className="text-primary-blue  file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                      id=""
                      {...register(
                        "email",
                        { required: false },
                        setValue("email", item.email)
                      )}
                    />
                  </div>
                  <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
                    <label htmlFor="" className="text-primary-red">
                      Address:
                    </label>
                    <input
                      type="text"
                      name="address"
                      className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                      id=""
                      {...register(
                        "address",
                        { required: false },
                        setValue("address", item.address)
                      )}
                    />
                  </div>
                  <div className="border-primary-blue border-2 border-t-0 p-2">
                    <p className="text-primary-red font-bold">Description</p>
                    <textarea
                      name="info"
                      className="w-full border border-gray-700"
                      id=""
                      rows="{10}"
                      {...register("info", setValue("info", item.info))}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-center">
                  <button
                    className="bg-primary-blue mt-3 text-center  gap-2 rounded-md px-5 py-3 font-bold text-white"
                    type="submit"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateEmployee;
